import {
  LicenseHeaderBriefInfo,
  LicenseNameAndAddress,
} from "../../../../../generated/data-contracts";
import { ResCallback } from "../../../../../models";
import { LicenseesUtils, TimeUtils } from "../../../../../utils";
import {
  AvisPersonValue,
  AvisSection,
  AvisValueRow,
} from "../../../../shared/components/form";

interface ILicenseBriefInfoProps {
  data: LicenseHeaderBriefInfo | undefined;
  res: ResCallback;
}
export function LicenseBriefInfo(props: Readonly<ILicenseBriefInfoProps>) {
  const { data, res } = props;

  const col1 = 6;
  const col2 = 6;

  const getLicenseObjects = (
    objects: LicenseNameAndAddress[] | undefined,
  ): React.ReactNode => {
    if (!objects) return <></>;

    const objectsCollection = objects.map((x, i) => {
      const objectValue = LicenseesUtils.getLicenseObjectValue(x);
      return (
        <div
          key={`object_${i}`}
          className="license-object-record table-cell-value-overflow"
          title={objectValue}
        >
          {objectValue}
        </div>
      );
    });

    return <div>{objectsCollection}</div>;
  };
  return (
    <AvisSection classNameIn="license-brief-info">
      <AvisValueRow
        rowTitle={res("licensees_License_label_Number")}
        rowValue={data?.licenseNumber}
        rowTitleCols={col1}
        rowValueCols={col2}
      />
      <AvisValueRow
        rowTitle={res("licensees_License_label_Person")}
        rowValue={<AvisPersonValue personInfo={data?.person} />}
        rowTitleCols={col1}
        rowValueCols={col2}
      />
      <AvisValueRow
        rowTitle={res("licensees_Invoice_label_Payor")}
        rowValue={<AvisPersonValue personInfo={data?.payor} />}
        rowTitleCols={col1}
        rowValueCols={col2}
      />
      <AvisValueRow
        rowTitle={res("licensees_License_label_Period")}
        rowValue={TimeUtils.formatPeriod(data?.dateFrom, data?.dateTo)}
        rowTitleCols={col1}
        rowValueCols={col2}
      />
      {!data?.isGroupingLicense && (
        <AvisValueRow
          rowTitle={res("licensees_License_label_ObjectName")}
          rowValue={getLicenseObjects(data?.objects)}
          rowTitleCols={col1}
          rowValueCols={col2}
        />
      )}
    </AvisSection>
  );
}
